<template>
  <div class="body">
    <div v-if="!dataTemplateAPR || dataTemplateAPR.length === 0">
      <div class="container_img_sem_risco">
        <img class="img_sem_risco" :src="semRisco">
      </div>
      <div class="container_img_sem_risco">
        <button type="button" class="btn btn-third button-novo-risco" @click="popUptAddServiceStage"><i class="fas fa-plus"></i> ADICIONAR ETAPA DE SERVIÇO</button>
      </div>
    </div>
    <div v-else>
    <b-card v-for="(data,index) in dataTemplateAPR" v-bind:key="index" no-body style="border: none; margin-bottom: 1rem; display: flex; ">
          <b-card-header header-tag="header" class="w-100 h-100 p-0 mb-0" role="tab" style="background-color: #008144; color: white; font-size: 13px;">
            <div  variant="info" class="head-mes d-flex align-items-center">
                <div class="title-left pl-3" v-on:click="toggleSection(index)">
                  <div class="title-colapse-mirror">{{data.etapaServico}}</div>
                </div>
                <div class="componente" v-on:click="toggleSection(index)">
                  <i v-if="!openSections.includes(index)" class="fas fa-angle-down arrow-angel" style="color: white; font-size: 16px;"></i>
                  <i v-else class="fas fa-angle-up arrow-angel" style="color: white; font-size: 16px;" ></i>
                </div>
                <div class="fa fa-trash mr-3" v-if="aprTemplateAgAprovacao === false && aprTemplateReprovado === false" @click="popUptDeleteServiceStage(data)" style="color: white;"></div>
              </div>
              </b-card-header>
              <b-collapse
                :visible="openSections.includes(index)"
                id="id"
                role="tabpanel"
                ref="testeacor"
                style="margin-bottom: 0;"
                >
                  <b-card-body style="padding: 0rem">
                    <div class="collapse-add-risco" v-if="aprTemplateAgAprovacao === false && aprTemplateReprovado === false">
                      <div class="button-collap-add-risco" @click="popUptAddRisco(data.etapaServicoId)"><i class="fas fa-plus"></i> ADICIONAR TIPO DE RISCO</div>
                    </div>
                    <div class="container-apr"  v-for="(dataRisco,index) in data.templateRiscosDto" :key="index" >
                      <div class="Header-Detalhes-Templete">
                        <div class="d-flex w-100">
                          <div class="font font-bold  tipo-apr">{{dataRisco.riscoDescricao}}</div>
                          <div v-if="aprTemplateAgAprovacao === false && aprTemplateReprovado === false" class="font font-bold  add" @click="popUptAdd(dataRisco.riscoId, data.etapaServicoId, data)">
                            <div class="icone-novo-risco"><i class="fas fa-plus"></i></div>
                            <div>NOVO RISCO</div>
                          </div>
                          <div v-if="aprTemplateAgAprovacao === false && aprTemplateReprovado === false" class="fa fa-trash exclur icone-lixeira" v-b-tooltip.hover :title="'Excluir Risco e todas as Causas'" @click="ExcluirCombo(dataRisco.riscoId, data.etapaServicoId)"></div>
                        </div>
                      </div>

                      <div class="Detalhes-Templete" v-for="dataCausa in dataRisco.itens" v-bind:key="dataCausa.causaId">
                      <div class="Coluna-Detalhes-risco" v-if="isFirstCause(dataCausa.causaId, dataRisco)">
                        <div class="Coluna-Detalhes-risco-parte1">
                          <div class="font-column">
                              RISCO
                          </div>
                        </div>
                        <div class="Coluna-Detalhes-risco-parte2">
                          <div class="Colunas-Detalhes-template">
                            <div class="font-column-matriz" v-b-tooltip.hover :title="'Severidade'">
                              S
                            </div>
                            <div class="font-column-matriz" v-b-tooltip.hover :title="'Probabilidade'">
                              P
                            </div>
                            <div class="font-column-matriz" v-b-tooltip.hover :title="'Cálculo Matriz de Risco'">
                              CR
                            </div>
                          </div>
                        </div>
                        <div class="Coluna-Detalhes-risco-parte3"></div>
                      </div>

                        <div class="Informacao-Detalhes-template">
                          <div class="riscos-container">
                            <div class="border-riscos ">
                              <div class="Coluna-Detalhes-Resultado-Risco-parte1">
                                <div class="risco-font-detalhe">{{dataCausa.causaDescricao}}</div>

                                <div class="barra" v-if="dataCausa.descricaoStatus !== null"></div>
                                <div class="tag" v-if="dataCausa.descricaoStatus !== null">
                                  <div class="tag_identintificacao" :style="{'background-color': dataCausa.colorStatusAPR, 'color': dataCausa.colorStatusAPRFonte}">{{dataCausa.descricaoStatus}}</div>
                                </div>
                              </div>

                              <div class="Coluna-Detalhes-Resultado-Risco-parte2">
                                <div class="card1">
                                  <div  b-v-tooltip.hover class="card-apr font-bold cursor" :style="{'background-color': card, 'color': fontCard}" @click="popUpAprAvaliacao(dataRisco.riscoId, dataRisco.id, dataRisco.revisao, dataCausa.causaId, dataRisco.emMemoria, dataCausa.severidade, dataCausa.probabilidade, dataCausa.classificacao, dataRisco.agAproacaoTemplateId, dataCausa, data.etapaServicoId)" >
                                    {{dataCausa.severidadeDescricao}}
                                  </div>
                                </div>

                                <div class="card1">
                                <div class="card-apr font-bold cursor" :style="{'background-color': card, 'color': fontCard}" @click="popUpAprAvaliacao(dataRisco.riscoId, dataRisco.id, dataRisco.revisao, dataCausa.causaId, dataRisco.emMemoria, dataCausa.severidade, dataCausa.probabilidade, dataCausa.classificacao, dataRisco.agAproacaoTemplateId, dataCausa, data.etapaServicoId)">
                                    {{dataCausa.probabilidadeDescricao}}
                                  </div>
                                </div>

                                <div class="card1">
                                  <div class="card-apr font-bold" :style="{'background-color': dataCausa.colorClassificacao == null ? 'red' : dataCausa.colorClassificacao, 'color': dataCausa.colorFonteClassificacao}">
                                    {{dataCausa.classificacaoDescricao}}
                                  </div>
                                </div>
                              </div>
                              <div class="Coluna-Detalhes-Resultado-Risco-parte3">
                                  <div v-if="aprTemplateAgAprovacao === false && dataCausa.descricaoStatus == null && aprTemplateReprovado === false" class="icone-edicao-risco icones"><i v-b-tooltip.hover :title="'Editar Risco'" class="fas fa-pencil-alt icone-fonte" @click="popUpAprEdicao(dataRisco.riscoId, dataCausa.causaId, dataCausa, data)"></i></div>
                                  <div class="icone-visualizacao-risco icones"  v-if="aprTemplateAgAprovacao === true ||  aprTemplateReprovado === true"><i v-b-tooltip.hover :title="'Visualizar Detalhes de Risco'" class="fas fa-eye icone-fonte" @click="popUpAprVisualizacao(dataRisco.riscoId, dataCausa.causaId, dataRisco.revisao, dataCausa)"></i></div>
                                  <div class="icone-visualizacao-risco icones" v-if="aprTemplateAgAprovacao === false && dataCausa.descricaoStatus === null && aprTemplateReprovado === false"><i v-b-tooltip.hover :title="'Excluir Natureza da Causa'" class="fa fa-trash text-danger icone-fonte" @click="excluirCausa(dataRisco.riscoId, dataCausa.causaId, data.etapaServicoId)"></i></div>
                                  <div class="icone-visualizacao-risco icones" v-if="aprTemplateAgAprovacao === false && dataCausa.descricaoStatus !== null  && aprTemplateReprovado === false"><i v-b-tooltip.hover :title="'Cancelar'" class="fas fa-times text-danger icone-fonte" @click="cancelarExclusao(dataRisco.riscoId, dataCausa.causaId, data.etapaServicoId)"></i></div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
              </b-card-body>
          </b-collapse>
      </b-card>

    </div>
    <b-modal ref="delete-etapa"
      size="md"
      centered
      title="novo template"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
    <template #modal-title>
        <div class="header-title">EXCLUIR ETAPA DE SERVIÇO</div>
    </template>
    <div class="etapadelete">
      <div class="msg-delete">
        <h6 class="title-delete">Deseja realizar a solicitação de exclusão dessa Etapa de Serviço?</h6>
        <div>*Todos os itens inclusos serão excluidos*</div>
      </div>
      <div class="d-flex container_cancel_save mt-3">
        <div class="cancelar" @click="closePopUp()">
          <button class="button-cancel">CANCELAR</button>
        </div>
        <div class="criar">
          <button class="button-delete" @click="ExclusaoComboEtapaServico()">Excluir</button>
        </div>
      </div>
    </div>
    </b-modal>
    <b-modal ref="adds-etapa"
      size="md"
      centered
      title="novo template"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
    <template #modal-title>
        <div class="header-title">ADICIONAR ETAPA DE SERVIÇO</div>
    </template>
      <addServiceStage
        :aprId="aprId"
        :dataTemplateAPR="dataTemplateAPR"
        :revisao="revisao"
        @cancelaEtapa="cancelaEtapa"
        @NovaEtapaServico="NovaEtapaServico">
      </addServiceStage>
    </b-modal>
    <b-modal ref="adds-riscos"
      size="md"
      centered
      title="novo template"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
    <template #modal-title>
        <div class="header-title">ADICIONAR RISCO</div>
    </template>
      <addAprRisk :aprId="aprId" :revisao="revisao" :etapaServicoId="etapaServicoId" @cancelaRiscos="cancelaRiscos" @NovoRisco="NovoRisco"></addAprRisk>
    </b-modal>

    <b-modal ref="add-risco"
      size="md"
      centered
      title="novo template"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
    <template #modal-title>
      <div class="header-title">{{aprVisualizacao === true ? 'APR' + ' - ' + codigo : UpAprEdicao === true ? 'EDITAR NATUREZA DO RISCO' :'ADICIONAR NATUREZA DO RISCO'}}</div>
    </template>
    <addRisk
      :SemEtapaServico="SemEtapaServico"
      :etapaServicoId="etapaServicoId"
      :UpAprEdicao="UpAprEdicao"
      :idAPRTemplate="aprId"
      :idRisco="idRisco"
      :revisao="revisao"
      :item="item"
      :causaAgEnvio="causaAgEnvio"
      :idMedida="idMedida"
      :idFonte="idFonte"
      :idConseguencia="idConseguencia"
      :revisaoPopUp="revisaoPopUp"
      :idCausa="idCausa"
      :causaMedidaFonteId="causaMedidaFonteId"
      :aprVisualizacao="aprVisualizacao"
      @cancelaRisco="cancelaRisco"
      @salvarRiscoFonteConsequenciaMedidaItens="salvarRiscoFonteConsequenciaMedidaItens"
      @editarRiscoFonteConsequenciaMedidaItens="editarRiscoFonteConsequenciaMedidaItens"
      @RiscoFonteMedidaConsequencia="RiscoFonteMedidaConsequencia"
    />
    </b-modal>

    <b-modal ref="risco-avalicao"
      size="md"
      centered
      title="Adicionar Template"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
    <template #modal-title>
      <div class="header-title">Avaliar</div>
    </template>
    <assessmentApr
    @matrizRisco="matrizRisco"
    @avaliacao="avaliacao"
    :edicaoAvaliacao="edicaoAvaliacao"
    :aprTemplateReprovado="aprTemplateReprovado"
    :aprTemplateAgAprovacao="aprTemplateAgAprovacao"
    :etapaServicoId="etapaServicoId"
    :avalicaoMemoria="avalicaoMemoria"
    :avalicaoP="avalicaoP"
    :avalicaoS="avalicaoS"
    :avalicaoCR="avalicaoCR"
    :avalicaoRiscoId="avalicaoRiscoId"
    :avalicaoAgAprovacaotemplateId="avalicaoAgAprovacaotemplateId"
    :avalicaotemplateId="avalicaotemplateId"
    :avalicaoCausaId="avalicaoCausaId"
    :causaMedidaFonteId="causaMedidaFonteId"
    :avalicaoRevisao="avalicaoRevisao"></assessmentApr>
    </b-modal>
  </div>

</template>

<script>
import tableByApr from './tableByApr'
export default tableByApr
</script>

  <style scoped>
  .icone-fonte{
    font-size: 16px;
  }
  .etapadelete{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .container_cancel_save{
    display: flex;
    gap: 1rem;
  }
  .msg-delete{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .title-delete{
    /* display: flex;
    justify-content: center; */
    display: flex;
    font-size: 18px;
    flex-direction: column;
    font-family: 'Segoe UI';
    gap: 1rem;
    text-align: center;
  }
  .button-collap-add-risco{
    display: flex;
    justify-content: center;
    cursor: pointer;
    gap: 10px;
    font-size: 12px;
    color: #008144;
    font-family: 'Segoe UI';
    font-weight: bold;
    align-items: center;
  }
  .button-novo-risco{
    font: normal normal 600 12px/24px Segoe UI;
    font-weight: bold;
  }
  .collapse-add-risco{
    height: 2rem;
    border-left: 2px dashed #d2d2d2;
    border-right: 2px dashed #d2d2d2;
    border-bottom: 2px dashed #d2d2d2;
    background-color: white;
    display: flex;
    justify-content: center;
  }
  .img_sem_risco{
    width: 24%;
    margin: 3rem;
  }
  .container_img_sem_risco{
    display: flex;
    padding: 1rem;
    justify-content: center;
  }
  .barra {
    border-left: 1px solid #d2d2d2;
    height: 2rem;
    margin: 0 10px 0 10px;
  }
  .Coluna-Detalhes-Resultado-Risco-parte3 {
    display: flex;
    justify-content: center;
    width: 10%;
    align-items: center;
    height: 100%;
    /* border-right: 1px solid #d2d2d2; */
  }
  .Coluna-Detalhes-Resultado-Risco-parte1 {
    display: flex;
    width: 75%;
    align-items: center;
    height: 100%;
    /* border-right: 1px solid #d2d2d2; */
  }
  .Coluna-Detalhes-Resultado-Risco-parte2 {
    display: flex;
    width: 15%;
    align-items: center;
    height: 100%;
    /* border-right: 1px solid #d2d2d2; */
  }
  .icone-novo-risco{
    display: flex;
    align-items: center;
    font-size: 10px;
    padding-right: 6px;
  }
  .icone-lixeira{
    font-size: 10px;
  }
  .Coluna-Detalhes-risco{
    display: flex;
    width: 100%;
    height: 2rem;
    background-color: white;
  }
  .Coluna-Detalhes-risco-parte1{
    display: flex;
    padding: 0 25px 0 10px;
    width: 75%;
    align-items: center;
    /* border-right: 1px solid #d2d2d2; */
  }
  .Coluna-Detalhes-risco-parte2{
    display: flex;
    width: 15%;
    align-items: center;
    /* border-right: 1px solid #d2d2d2; */
  }
  .body{
    width: 100%;
  }
  .container-apr{
    margin-bottom: 1rem;
  }
  .riscos-container{
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .border-meio-div{
    border-left: 1px solid #d2d2d2;
  }
  .border-riscos {
    display: flex;
    height: 3.5rem;
    align-items: center;
  }
  .risco-font-detalhe{
    padding: 0 0 0 8px;
    width: fit-content;
  }
  .tag{
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    border-radius: 20px;
    height: 100%;
  }
  .tag_identintificacao{
    width: fit-content;
    height: 1.6rem;
    text-align: center;
    border-radius: 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 10px;
    padding: 0 5px 0 5px;
    font-weight: bold;
  }
  .header-title{
    color: white;
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
  .icone-edicao-risco{
    display: flex;
    cursor: pointer;
    justify-content: end;
  }
  .icone-visualizacao-risco{
    display: flex;
    cursor: pointer;
    justify-content: end;
  }
  .Header-Detalhes-Templete{
    padding: 5px 16px 5px 10px;
    width: 100%;
    height: 2rem;
    background-color: #f5f5f5;
  }
  .Colunas-Detalhes-template{
    align-items: center;
    justify-content: center;
    display: flex;
    width: 100%;
    height: 2rem;
  }
  .Informacao-Detalhes-template{
    display: flex;
    /* border: 1px solid #c9c9c9; */
    border-top: 1px solid #ededed;
    /* border-bottom: 1px solid #c9c9c9; */
    justify-content: initial;
    align-items: center;
    width: 100%;

    height: fit-content;
  }
  .font-column{
    font-size: 12px;
    color: #008144;
    font-family: 'Segoe UI';
    font-weight: bold;
  }
    .font-column-matriz{
    font-size: 12px;
    color: #008144;
    font-family: 'Segoe UI';
    font-weight: bold;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .font {
    font-family: 'Segoe UI';
    font-size: 12px;
    color: #008144;
  }
  .tipo-apr{
    width: 80%;
  }
  .add{
    width: 20%;
    cursor: pointer;
    display: flex;
    justify-content: end;
  }
  .exclur{
    width: 3%;
    cursor: pointer;
    display: flex;
    justify-content: end;
    align-items: center;
    color:#008144;
  }
  .card-container{
    display: flex;
    border-left: 1px solid #d2d2d2;
    align-items: center;
    height: 3.5rem;
    column-gap: 0.5rem;
    padding: 0 1rem;
  }
  .font-bold {
    font-weight: bold;
  }
  .cursor {
    cursor: pointer;
  }
  .card-apr{
    font-size: 12px;
    font-family: 'Segoe UI';
    border-radius: 5px;
    width: 2.2rem;
    height: 2.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card1{
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .icones {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .extendeCollapsebtn, .extendeCollapsebtn:hover {
    border-radius:5px;
    color:white;
    height:35px;
    width: 15%;
    border: 1px solid #CED4DA;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .extendeCollapsebtn{
    background-color:#008148;
  }
  .extendeCollapsebtn:hover{
    background-color:#03AC61;
  }
  .shrumpCollapsebtn, .shrumpCollapsebtn:hover{
    border-radius:5px;
    color:grey;
    height:35px;
    width: 15%;
    border: 1px solid #CED4DA;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .shrumpCollapsebtn{
    background-color:#F5F5F5;
  }
  .shrumpCollapsebtn:hover{
    background-color: #e4e5e6;;
  }
  .shrumpExtende{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
  }
  .descricao-delete-model{
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .delete-model {
    gap: 1rem;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    font-size: 14px;
    font-family: 'Segoe UI';
  }
 .container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
  }

.button-cancel,.button-save,.button-delete{
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }
  .button-cancel{
    background-color: #dedede;
    color: #747474;
  }
  .button-save{
    background-color: #008148;
    color: white;
  }
  .button-delete{
    background-color: #dc3545;
    color: white;
  }
  .header-title{
    color: white;
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
 .buttonaprova{
    height: 45px;
    display: flex;
    border-top: 1px solid #dee2e6;
  }
  .btn-rep{
    width: 10vw;
    background: red;
    margin-right: 5px;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
  }
.btn-appr{
    width: 10vw;
    background: #008144;
    color: white;
    margin-left: 5px;
    border: none;
    border-radius: 5px;
    font-weight: bold;
  }
.title-left{
display: flex;
width: 100%;
height: 100%;
align-items: center;
}
.teste {
width:auto;
height: 300px;
overflow-x: scroll;
}

.tamanhofixo
{
text-align: center;
min-width: 300px;
}
.title-colapse-mirror{
font-weight: bold;
font-family: 'Segoe UI';
font-size: 13px;
}
.table-cus{
width: 550%;
overflow-y: scroll;
}
thead{
width: 400px;
overflow: auto;
}
.componente{
font-size: 18px;
color: black;
padding-top: 9px;
padding-left: 15px;
display: flex;
}

.head-mes{
display: flex;
height: 40px;
align-items: center;
justify-content: space-between;
cursor: pointer;
}
.arrow-angel{
font-size: 30px;
color: black;
padding-right: 20px;
padding-bottom: 10px;
}
.collapse-max{
overflow: auto;
height: 40vh;
}
  </style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/components/tableByApr/tableByApr.vue